export default __webpack_public_path__ + "static/media/labelDimension.8d9fc2e6.png";